import { AppSettings } from 'src/app/enums/app-settings.enum';
import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from 'src/app/services/cart.service';
import { ContactService } from 'src/app/services/contact.service';
import { CustomerfeedbackmanagementService } from 'src/app/services/customerfeedbackmanagement.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavBarComponent implements OnInit {
  @Input() label: any;
  @Input() count: any;
  @Input() deliveryReview: boolean = false;
  isNavCollapsed: boolean = true;
  userLoggedIn: boolean = false;
  userData: any;
  language: any = '';
  ENV: any;
  cart: any;
  items: any;
  isGuestUser: boolean =false;
  currentLanguage: string;
  constructor(
    private CNS: ContactService,
    public translate: TranslateService,
    private SS: SubjectService,
    private modalController: ModalController,
    private CS: CartService,
    private UTS: UtilitiesService,
    private GAS: GoogleAnalyticsService,
    private aRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private router:Router,
    private CFM: CustomerfeedbackmanagementService
  ) { }

  ngOnInit() {
    this.ENV = this.UTS.getENV();
    this.getUserInfo();

    this.SS.getAccountDetails.subscribe(x => {
      if (x == true) {
        this.getUserInfo();
        this.getCart();
      }
    });
    this.currentLanguage = this.UTS.getLocaleLanguage();

  }

  getUserInfo() {
    this.language = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    this.CNS.getUserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userData = r;
          this.userLoggedIn = true;
          this.CFM.checkcustomerFeedback(this.userData)
          const accessToken = localStorage.getItem('AccessToken');
          if (accessToken && (accessToken != null || accessToken.toLocaleLowerCase() != "null")) {
            this.isGuestUser = false;
            this.userLoggedIn = true;
          }
          else {
            this.isGuestUser = true;
          }
          this.getCart();
        }
        this.cdr.detectChanges();
      },
      () => {
        this.userLoggedIn = false;
        this.isGuestUser = true;
        this.getCart();
        this.CFM.userNotLogin()
        this.cdr.detectChanges();
      }
    );
  }
  getCart() {
    this.count = 0;
    this.CS.getShoppingCart().subscribe(
      (r: any) => {
        if (r && r.items) {
          this.count = r?.numberOfItemsInCart
            ? r?.numberOfItemsInCart
            : 0;
            this.cdr.detectChanges();
        }
      },
      (e) => {
        if (e && e.error) {
          // this.UTS.error(e.error.message);
        }
      }
    );
  }
  signIn() {
    window.location.href = AppSettings.SIGN_IN_URL;
  }


  changeLangAction() {

    const lang = (localStorage.getItem('language'))? localStorage.getItem('language') :  'en';
    if (lang.toLocaleLowerCase() == 'en') {
      this.UTS.setLocaleLanguage('ar');
      const index = window.location.href.indexOf('lang');
      let url = "";
      if(index !== -1){
        url = window.location.href.replace("lang=en","lang=ar");
      }else{
        const data = window.location.href.split('?');
        if(data?.length > 1){
          url = window.location.href + '&lang=ar';
        }else{
          url = window.location.href.split('?') && window.location.href.split('?')[0] ? window.location.href.split('?')[0] + '?lang=ar' : window.location.href.split('?')[0] + '?lang=ar';
        }
      }
      window.location.href = url;
      // window.location.reload();
    }

    if (lang.toLocaleLowerCase() == 'ar') {
      this.UTS.setLocaleLanguage('en');
      const index = window.location.href.indexOf('lang');
      let url = "";
      if(index !== -1){
        url = window.location.href.replace("lang=ar","lang=en");
      }else{
        const data = window.location.href.split('?');
        if(data?.length > 1){
          url = window.location.href + '&lang=en';
        }else{
          url = window.location.href.split('?') && window.location.href.split('?')[0] ? window.location.href.split('?')[0] + '?lang=en' : window.location.href.split('?')[0] + '?lang=en';
        }
      }
      window.location.href = url;
      // window.location.reload();
    }

  }

  logOut() {
    this.CNS.logOut().subscribe(res => {
      this.signIn();
    });
  }

  trackOrder() {
    const lang = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    window.location.href = environment.HOST + '/b2c/eshop/userOrdersTracking?locale='+lang;
  }

  goToCart() {
    let product = [];
    if(this.items && this.items.length >0){
      this.items.filter((data) => {
        product.push(data.displayName);
      });
    }
    this.GAS.checkout('checkout', product);
    this.modalController.dismiss();
    setTimeout(() => {
      window.location.href = `/b2c/heshop/checkoutApp/cart?lang=${this.currentLanguage}`;
    }, 500);

  }


  dismiss() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {

      (window as any).deals.goBack();

    } else if (this.ENV == 'mobile' && OS == 'iOS') {

      (window as any).webkit.messageHandlers.hybridInterface.postMessage('goBack');

    }
    else
      window.location.href =  '/b2c/eshop/';
  }


  backToHome() {
    if (this.label.toLocaleLowerCase() == 'cart' || this.deliveryReview) {
      const OS = this.UTS.getMobileOperatingSystem();
      if (this.ENV == 'mobile' && OS == 'Android') {

        (window as any).deals.resumeOnBack();

      } else if (this.ENV == 'mobile' && OS == 'iOS') {

        (window as any).webkit.messageHandlers.hybridInterface.postMessage('resumeOnBack');

      }
      else
        window.location.href =  '/b2c/eshop/';
    }
    else {
      history.back();
    }
  }

  logoutMobile() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {

      (window as any).deals.logout();

    } else if (this.ENV == 'mobile' && OS == 'iOS') {

      (window as any).webkit.messageHandlers.hybridInterface.postMessage('logout');

    }
  }
  gotoSamplePurchase(){
    this.router.navigate(['/sample-purchase'])
  }

  homePage(){
    window.location.href = 'https://www.eand.ae/en/index.html';
  }
}
